(function (global, factory) {
	typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports, require('@angular/common'), require('@angular/core'), require('@gomus/auth'), require('@angular/common/http'), require('rxjs/add/operator/map'), require('@angular/router')) :
	typeof define === 'function' && define.amd ? define(['exports', '@angular/common', '@angular/core', '@gomus/auth', '@angular/common/http', 'rxjs/add/operator/map', '@angular/router'], factory) :
	(factory((global.common = {}),global.common,global.core,global.auth,global.http,null,global.router));
}(this, (function (exports,common,core,auth,http,map,router) { 'use strict';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var LoaderService = (function () {
    function LoaderService() {
        this.spinnerCache = new Set();
    }
    /**
     * @param {?} spinner
     * @return {?}
     */
    LoaderService.prototype._register = /**
     * @param {?} spinner
     * @return {?}
     */
    function (spinner) {
        this.spinnerCache.add(spinner);
    };
    /**
     * @param {?} spinnerToRemove
     * @return {?}
     */
    LoaderService.prototype._unregister = /**
     * @param {?} spinnerToRemove
     * @return {?}
     */
    function (spinnerToRemove) {
        var _this = this;
        this.spinnerCache.forEach(function (spinner) {
            if (spinner === spinnerToRemove) {
                _this.spinnerCache.delete(spinner);
            }
        });
    };
    /**
     * @return {?}
     */
    LoaderService.prototype._unregisterAll = /**
     * @return {?}
     */
    function () {
        this.spinnerCache.clear();
    };
    /**
     * @param {?} spinnerName
     * @param {?=} state
     * @param {?=} text
     * @return {?}
     */
    LoaderService.prototype.update = /**
     * @param {?} spinnerName
     * @param {?=} state
     * @param {?=} text
     * @return {?}
     */
    function (spinnerName, state, text) {
        if (state === void 0) { state = 'loaded'; }
        this.spinnerCache.forEach(function (spinner) {
            if (spinner.name === spinnerName) {
                spinner.state = state;
                (/** @type {?} */ (spinner)).text = text;
            }
        });
    };
    /**
     * @param {?} state
     * @return {?}
     */
    LoaderService.prototype.updateAll = /**
     * @param {?} state
     * @return {?}
     */
    function (state) {
        this.spinnerCache.forEach(function (spinner) { return spinner.state = state; });
    };
    /**
     * @param {?} spinnerName
     * @return {?}
     */
    LoaderService.prototype.getState = /**
     * @param {?} spinnerName
     * @return {?}
     */
    function (spinnerName) {
        var /** @type {?} */ showing;
        this.spinnerCache.forEach(function (spinner) {
            if (spinner.name === spinnerName) {
                showing = spinner.state;
            }
        });
        return showing;
    };
    LoaderService.decorators = [
        { type: core.Injectable },
    ];
    /** @nocollapse */
    LoaderService.ctorParameters = function () { return []; };
    return LoaderService;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var LoaderComponent = (function () {
    function LoaderComponent(loaderService) {
        this.loaderService = loaderService;
        this._state = 'loading';
        this.showChange = new core.EventEmitter();
    }
    Object.defineProperty(LoaderComponent.prototype, "state", {
        get: /**
         * @return {?}
         */
        function () {
            return this._state;
        },
        set: /**
         * @param {?} val
         * @return {?}
         */
        function (val) {
            this._state = val;
            this.showChange.emit(this._state);
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @return {?}
     */
    LoaderComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        if (!this.name) {
            throw new Error('Spinner must have a "name" attribute.');
        }
        this.loaderService._register(this);
    };
    /**
     * @return {?}
     */
    LoaderComponent.prototype.ngOnDestroy = /**
     * @return {?}
     */
    function () {
        this.loaderService._unregister(this);
    };
    LoaderComponent.decorators = [
        { type: core.Component, args: [{
                    selector: 'go-loader[name],[go-loader][name]',
                    template: "<ng-container [ngSwitch]=\"_state\"> <!-- <ng-content select=\"[error]\" *ngSwitchCase=\"'error'\"></ng-content> --> <!-- <ng-content select=\"[loading]\" *ngSwitchCase=\"'loading'\"></ng-content> --> <div *ngSwitchCase=\"'error'\" class=\"alert alert-danger\">{{text}}</div> <div *ngSwitchCase=\"'empty'\" class=\"alert alert-warning\">{{text}}</div> <img *ngSwitchCase=\"'loading'\" src=\"data:image/gif;base64,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\" alt=\"\"> <ng-content *ngSwitchCase=\"'loaded'\"></ng-content> </ng-container> ",
                    styles: ["\n    img {\n      display: block;\n      width: 50px;\n      margin: 50px auto;\n    }\n  "]
                },] },
    ];
    /** @nocollapse */
    LoaderComponent.ctorParameters = function () { return [
        { type: LoaderService, },
    ]; };
    LoaderComponent.propDecorators = {
        "name": [{ type: core.Input },],
        "group": [{ type: core.Input },],
        "state": [{ type: core.Input },],
        "showChange": [{ type: core.Output },],
    };
    return LoaderComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var LoaderDirective = (function () {
    function LoaderDirective(ref, loader) {
        this.ref = ref;
        this.loader = loader;
        this.isShowing = false;
    }
    Object.defineProperty(LoaderDirective.prototype, "show", {
        get: /**
         * @return {?}
         */
        function () {
            return this.isShowing;
        },
        set: /**
         * @param {?} val
         * @return {?}
         */
        function (val) {
            this.isShowing = val;
            if (val) {
                this.ref.nativeElement.innerHTML = "<img class=\"loader\" src=\"data:image/gif;base64,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\">" + this.content;
                this.disabled = true;
            }
            else {
                this.ref.nativeElement.innerHTML = this.content;
                this.disabled = null;
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LoaderDirective.prototype, "state", {
        set: /**
         * @param {?} state
         * @return {?}
         */
        function (state) {
            this.show = state === 'loading' ? true : false;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @return {?}
     */
    LoaderDirective.prototype.ngAfterContentInit = /**
     * @return {?}
     */
    function () {
        this.loader._register(this);
        this.content = this.ref.nativeElement.innerHTML;
    };
    /**
     * @return {?}
     */
    LoaderDirective.prototype.ngOnDestroy = /**
     * @return {?}
     */
    function () {
        this.loader._unregister(this);
    };
    LoaderDirective.decorators = [
        { type: core.Directive, args: [{
                    selector: '[go-loader]'
                },] },
    ];
    /** @nocollapse */
    LoaderDirective.ctorParameters = function () { return [
        { type: core.ElementRef, },
        { type: LoaderService, },
    ]; };
    LoaderDirective.propDecorators = {
        "name": [{ type: core.Input, args: ['go-loader',] },],
        "disabled": [{ type: core.HostBinding, args: ['attr.disabled',] },],
        "show": [{ type: core.Input },],
    };
    return LoaderDirective;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var LoaderModule = (function () {
    function LoaderModule() {
    }
    /**
     * @return {?}
     */
    LoaderModule.forRoot = /**
     * @return {?}
     */
    function () {
        return {
            ngModule: LoaderModule,
            providers: [LoaderService]
        };
    };
    LoaderModule.decorators = [
        { type: core.NgModule, args: [{
                    imports: [
                        common.CommonModule
                    ],
                    declarations: [LoaderComponent, LoaderDirective],
                    exports: [LoaderComponent, LoaderDirective]
                },] },
    ];
    /** @nocollapse */
    LoaderModule.ctorParameters = function () { return []; };
    return LoaderModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/**
 * @license
 * Copyright Giant Monkey Software Engineering All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://github.com/giantmonkey/gomus-components/blob/master/LICENSE
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var ModalService = (function () {
    function ModalService() {
        this.modals = new Set();
    }
    /**
     * @param {?} modal
     * @return {?}
     */
    ModalService.prototype.add = /**
     * @param {?} modal
     * @return {?}
     */
    function (modal) {
        // add modal to array of active modals
        this.modals.add(modal);
    };
    /**
     * @param {?} modal
     * @return {?}
     */
    ModalService.prototype.remove = /**
     * @param {?} modal
     * @return {?}
     */
    function (modal) {
        // remove modal from array of active modals
        this.modals.delete(modal);
    };
    /**
     * @param {?} id
     * @return {?}
     */
    ModalService.prototype.open = /**
     * @param {?} id
     * @return {?}
     */
    function (id) {
        // open modal specified by modal: ModalComponent modal: any = find(this.modals, { id: id });
        this.modals.forEach(function (modal) {
            if (modal.id === id) {
                modal.open();
                return false;
            }
        });
    };
    /**
     * @param {?} id
     * @return {?}
     */
    ModalService.prototype.close = /**
     * @param {?} id
     * @return {?}
     */
    function (id) {
        // close modal specified by id
        this.modals.forEach(function (modal) {
            if (modal.id === id) {
                modal.close();
                return false;
            }
        });
    };
    ModalService.decorators = [
        { type: core.Injectable },
    ];
    /** @nocollapse */
    ModalService.ctorParameters = function () { return []; };
    return ModalService;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var ModalComponent = (function () {
    function ModalComponent(modalService, el, renderer, document) {
        this.modalService = modalService;
        this.el = el;
        this.renderer = renderer;
        this.document = document;
    }
    /**
     * @param {?} e
     * @return {?}
     */
    ModalComponent.prototype.onClick = /**
     * @param {?} e
     * @return {?}
     */
    function (e) {
        if (e.target.id === 'modal' || e.target.className.indexOf('close') >= 0) {
            this.close();
        }
    };
    /**
     * @return {?}
     */
    ModalComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        // ensure id attribute exists
        if (!this.id) {
            console.error('modal must have an id');
            return;
        }
        // move element to bottom of page (just before </body>) so it can be displayed above everything else
        this.renderer.appendChild(this.document.body, this.el.nativeElement);
        // add self (this modal instance) to the modal service so it's accessible from controllers
        this.modalService.add(this);
    };
    // remove self from modal service when directive is destroyed
    /**
     * @return {?}
     */
    ModalComponent.prototype.ngOnDestroy = /**
     * @return {?}
     */
    function () {
        this.modalService.remove(this);
        this.renderer.removeChild(this.document.body, this.el.nativeElement);
    };
    // open modal
    /**
     * @return {?}
     */
    ModalComponent.prototype.open = /**
     * @return {?}
     */
    function () {
        this.renderer.addClass(this.el.nativeElement, 'open');
        this.renderer.addClass(this.modal.nativeElement, 'show');
        this.renderer.addClass(this.document.body, 'modal-open');
    };
    // close modal
    /**
     * @return {?}
     */
    ModalComponent.prototype.close = /**
     * @return {?}
     */
    function () {
        this.renderer.removeClass(this.el.nativeElement, 'open');
        this.renderer.removeClass(this.modal.nativeElement, 'show');
        this.renderer.removeClass(this.document.body, 'modal-open');
    };
    ModalComponent.decorators = [
        { type: core.Component, args: [{
                    selector: 'go-modal',
                    template: '<ng-content></ng-content>',
                    styles: ["go-modal { position: fixed; top: 0; right: 0; bottom: 0; left: 0; display: none; } go-modal.open { display: block; } go-modal .modal { display: block; } "],
                    encapsulation: core.ViewEncapsulation.None
                },] },
    ];
    /** @nocollapse */
    ModalComponent.ctorParameters = function () { return [
        { type: ModalService, },
        { type: core.ElementRef, },
        { type: core.Renderer2, },
        { type: undefined, decorators: [{ type: core.Inject, args: [common.DOCUMENT,] },] },
    ]; };
    ModalComponent.propDecorators = {
        "id": [{ type: core.Input },],
        "modal": [{ type: core.ContentChild, args: ['modal',] },],
        "onClick": [{ type: core.HostListener, args: ['click', ['$event'],] },],
    };
    return ModalComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var ModalModule = (function () {
    function ModalModule() {
    }
    ModalModule.decorators = [
        { type: core.NgModule, args: [{
                    imports: [
                        common.CommonModule
                    ],
                    declarations: [ModalComponent],
                    exports: [ModalComponent],
                    providers: [ModalService]
                },] },
    ];
    /** @nocollapse */
    ModalModule.ctorParameters = function () { return []; };
    return ModalModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/**
 * @license
 * Copyright Giant Monkey Software Engineering All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://github.com/giantmonkey/gomus-components/blob/master/LICENSE
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/**
 * @record
 */

/**
 * @record
 */

var GoConfiguration = (function () {
    function GoConfiguration(options) {
    }
    return GoConfiguration;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/**
 * @license
 * Copyright Giant Monkey Software Engineering All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://github.com/giantmonkey/gomus-components/blob/master/LICENSE
 */

var __assign = (undefined && undefined.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var END_POINTS = new core.InjectionToken('END_POINTS');
var API = (function () {
    function API(_endPoints, _goConfig, _http, loader) {
        this._endPoints = _endPoints;
        this._goConfig = _goConfig;
        this._http = _http;
        this.loader = loader;
        this._baseUrl = "https://" + document.location.host.replace('.demo.kasse', '').replace('-kasse', '').replace('-integration', '');
        this.endPoints = _endPoints.reduce(function (acc, current) {
            return __assign({}, current, acc);
        }, {});
    }
    /**
     * @param {?} url
     * @param {?=} params
     * @return {?}
     */
    API.prototype.resolve = /**
     * @param {?} url
     * @param {?=} params
     * @return {?}
     */
    function (url, params) {
        if (!url) {
            return;
        }
        if (!params) {
            return "" + this._baseUrl + url;
        }
        var /** @type {?} */ resolved = Object.keys(params).reduce(function (acc, param) {
            return acc.replace(":" + param, params[param]);
        }, url);
        return "" + this._baseUrl + resolved;
    };
    // TODO implement
    /**
     * @return {?}
     */
    API.prototype.handleError = /**
     * @return {?}
     */
    function () { };
    /**
     * @param {...?} args
     * @return {?}
     */
    API.prototype.updateLoader = /**
     * @param {...?} args
     * @return {?}
     */
    function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        if (this.loader) {
            this.loader.update(args[0], args[1], args[3]);
        }
    };
    API.decorators = [
        { type: core.Injectable },
    ];
    /** @nocollapse */
    API.ctorParameters = function () { return [
        { type: undefined, decorators: [{ type: core.Inject, args: [END_POINTS,] },] },
        { type: undefined, decorators: [{ type: core.Inject, args: [GO_CONFIGURATION,] },] },
        { type: http.HttpClient, },
        { type: LoaderService, decorators: [{ type: core.Optional },] },
    ]; };
    return API;
}());

var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var ConfigApiService = (function (_super) {
    __extends(ConfigApiService, _super);
    function ConfigApiService() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * @return {?}
     */
    ConfigApiService.prototype.getConfig = /**
     * @return {?}
     */
    function () {
        return this._http.get(this.resolve(this.endPoints["config"])).map(function (data) { return data['shop']; }).share();
    };
    return ConfigApiService;
}(API));

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var GO_CONFIGURATION = new core.InjectionToken('GO_CONFIGURATION');
var noopConfiguration = {};
/**
 * @record
 */

var ConfigService = (function () {
    function ConfigService(_goConfig, _api, _auth) {
        this._goConfig = _goConfig;
        this._api = _api;
        this._auth = _auth;
        this.init();
    }
    /**
     * @return {?}
     */
    ConfigService.prototype.hasConfig = /**
     * @return {?}
     */
    function () {
        if (this.config) {
            return true;
        }
        else {
            return this._api.getConfig().map(function () { return true; }, function () { return false; });
        }
    };
    /**
     * @param {?=} key
     * @return {?}
     */
    ConfigService.prototype.getUrl = /**
     * @param {?=} key
     * @return {?}
     */
    function (key) {
        var /** @type {?} */ prefix;
        if (key) {
            prefix = "https://" + this.config['url'];
        }
        else {
            prefix = 'https://';
            key = 'url';
        }
        return "" + prefix + this.config[key];
    };
    /**
     * @param {?} key
     * @return {?}
     */
    ConfigService.prototype.getSetting = /**
     * @param {?} key
     * @return {?}
     */
    function (key) {
        return this.settings ? this.settings[key] : '';
    };
    /**
     * @param {?} key
     * @return {?}
     */
    ConfigService.prototype.getTranslation = /**
     * @param {?} key
     * @return {?}
     */
    function (key) {
        return this.translations ? this.translations[key] : '';
    };
    /**
     * @return {?}
     */
    ConfigService.prototype.init = /**
     * @return {?}
     */
    function () {
        if (this._goConfig && document.location.host.replace('.demo.kasse', '').replace('-kasse', '').replace('-integration', '') && this._goConfig.shop_domain) {
            this.domain = { gomus: document.location.host.replace('.demo.kasse', '').replace('-kasse', '').replace('-integration', ''), shop: this._goConfig.shop_domain };
            this.getConfig();
        }
        else if (this._goConfig) {
            this.updateConfig(this._goConfig);
            this.domain = { gomus: document.location.host.replace('.demo.kasse', '').replace('-kasse', '').replace('-integration', ''), shop: this._goConfig.shop_domain };
        }
        // else if (_gomusOptions && typeof _gomusOptions === 'object') {
        //   this.updateConfig(new GoConfiguration(_gomusOptions))
        //   if (_gomusOptions.domain) { this.getConfig() }
        // }
    };
    /**
     * @return {?}
     */
    ConfigService.prototype.initAuth = /**
     * @return {?}
     */
    function () {
        if (!this._auth) {
            return;
        }
        this._auth.init({
            apiBase: "https://" + this.domain.gomus + "/api/v4",
            registerAccountCallback: this.getUrl('confirmation_link'),
            resetPasswordCallback: this.getUrl('password_reset_link'),
            websiteHost: this.getUrl()
        });
    };
    /**
     * @return {?}
     */
    ConfigService.prototype.getConfig = /**
     * @return {?}
     */
    function () {
        var _this = this;
        if (this.sub)
            return;
        this.sub = this._api.getConfig().subscribe(function (config) {
            _this.updateConfig(config);
            _this.initAuth();
        });
    };
    /**
     * @param {?} config
     * @return {?}
     */
    ConfigService.prototype.updateConfig = /**
     * @param {?} config
     * @return {?}
     */
    function (config) {
        Object.assign(this, config);
    };
    ConfigService.decorators = [
        { type: core.Injectable },
    ];
    /** @nocollapse */
    ConfigService.ctorParameters = function () { return [
        { type: undefined, decorators: [{ type: core.Inject, args: [GO_CONFIGURATION,] },] },
        { type: ConfigApiService, },
        { type: auth.AuthService, decorators: [{ type: core.Optional },] },
    ]; };
    return ConfigService;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/**
 * @license
 * Copyright Giant Monkey Software Engineering All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://github.com/giantmonkey/gomus-components/blob/master/LICENSE
 */
/**
 * A collection of Angular directives that are likely to be used in each and every gomus Components
 * application.
 */
var COMMON_SERVICES = [
    ConfigService,
    ConfigApiService,
    API
];

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/**
 * @license
 * Copyright Giant Monkey Software Engineering All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://github.com/giantmonkey/gomus-components/blob/master/LICENSE
 */
var TranslatePipe = (function () {
    function TranslatePipe(configService) {
        this.configService = configService;
    }
    /**
     * @param {?} value
     * @param {?=} args
     * @return {?}
     */
    TranslatePipe.prototype.transform = /**
     * @param {?} value
     * @param {?=} args
     * @return {?}
     */
    function (value, args) {
        var /** @type {?} */ fallback = this.configService.getSetting('show_translation_keys') ? value : '';
        return this.configService.getTranslation(value) || fallback;
    };
    TranslatePipe.decorators = [
        { type: core.Pipe, args: [{
                    name: 'goTranslate'
                },] },
    ];
    /** @nocollapse */
    TranslatePipe.ctorParameters = function () { return [
        { type: ConfigService, },
    ]; };
    return TranslatePipe;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
// /**
//  * @license
//  * Copyright Giant Monkey Software Engineering All Rights Reserved.
//  *
//  * Use of this source code is governed by an MIT-style license that can be
//  * found in the LICENSE file at https://github.com/giantmonkey/gomus-components/blob/master/LICENSE
//  */
/**
 * A collection of Angular pipes that are likely to be used in each and every gomus Components
 * application.
 */
var COMMON_PIPES = [
    TranslatePipe
];

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/**
 * @license
 * Copyright Giant Monkey Software Engineering All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://github.com/giantmonkey/gomus-components/blob/master/LICENSE
 */
var LocaleSwitcherDirective = (function () {
    function LocaleSwitcherDirective(router$$1, activatedRoute, document) {
        this.router = router$$1;
        this.activatedRoute = activatedRoute;
        this.document = document;
    }
    /**
     * @return {?}
     */
    LocaleSwitcherDirective.prototype.onClick = /**
     * @return {?}
     */
    function () {
        var _this = this;
        localStorage.setItem('go-locale', this.lang);
        this.router.onSameUrlNavigation = 'reload';
        var /** @type {?} */ queryParams = Object.assign({}, this.activatedRoute.snapshot.queryParams);
        queryParams['lang'] = this.lang;
        this.router.navigate([], { queryParams: queryParams, relativeTo: this.activatedRoute }).then(function () {
            _this.document.location.reload();
        });
    };
    LocaleSwitcherDirective.decorators = [
        { type: core.Directive, args: [{
                    selector: '[go-locale-switcher]'
                },] },
    ];
    /** @nocollapse */
    LocaleSwitcherDirective.ctorParameters = function () { return [
        { type: router.Router, },
        { type: router.ActivatedRoute, },
        { type: undefined, decorators: [{ type: core.Inject, args: [common.DOCUMENT,] },] },
    ]; };
    LocaleSwitcherDirective.propDecorators = {
        "lang": [{ type: core.Input, args: ['go-locale-switcher',] },],
        "onClick": [{ type: core.HostListener, args: ['click',] },],
    };
    return LocaleSwitcherDirective;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/**
 * @license
 * Copyright Giant Monkey Software Engineering All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://github.com/giantmonkey/gomus-components/blob/master/LICENSE
 */
var TranslateDirective = (function () {
    function TranslateDirective(el, renderer, configService) {
        this.el = el;
        this.renderer = renderer;
        this.configService = configService;
    }
    Object.defineProperty(TranslateDirective.prototype, "translateValues", {
        set: /**
         * @param {?} value
         * @return {?}
         */
        function (value) {
            this._translateValues = value;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @return {?}
     */
    TranslateDirective.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        var /** @type {?} */ fallback = this.configService.getSetting('show_translation_keys') ? this.translate : '';
        this.translation = this.configService.getTranslation(this.translate) || fallback;
        this.renderKeys();
    };
    /**
     * @param {?} changes
     * @return {?}
     */
    TranslateDirective.prototype.ngOnChanges = /**
     * @param {?} changes
     * @return {?}
     */
    function (changes) {
        if (this.translation && changes["translate"] && changes["translate"].currentValue !== changes["translate"].previousValue) {
            this.ngOnInit();
        }
        else if (this.translation && changes["translateValues"] && changes["translateValues"].currentValue !== changes["translateValues"].previousValue) {
            this.renderKeys();
        }
    };
    /**
     * @return {?}
     */
    TranslateDirective.prototype.render = /**
     * @return {?}
     */
    function () {
        this.renderer.setElementProperty(this.el.nativeElement, 'innerHTML', this.translation);
    };
    /**
     * @return {?}
     */
    TranslateDirective.prototype.renderKeys = /**
     * @return {?}
     */
    function () {
        if (this._translateValues) {
            for (var /** @type {?} */ key in this._translateValues) {
                if (this._translateValues.hasOwnProperty(key)) {
                    this.translation = this.translation.replace("{{" + key + "}}", this._translateValues[key]);
                }
            }
        }
        this.render();
    };
    TranslateDirective.decorators = [
        { type: core.Directive, args: [{
                    selector: '[go-translate]'
                },] },
    ];
    /** @nocollapse */
    TranslateDirective.ctorParameters = function () { return [
        { type: core.ElementRef, },
        { type: core.Renderer, },
        { type: ConfigService, },
    ]; };
    TranslateDirective.propDecorators = {
        "translate": [{ type: core.Input, args: ['go-translate',] },],
        "translateValues": [{ type: core.Input, args: ['translate-values',] },],
    };
    return TranslateDirective;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/**
 * @license
 * Copyright Giant Monkey Software Engineering All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://github.com/giantmonkey/gomus-components/blob/master/LICENSE
 */
/**
 * A collection of Angular directives that are likely to be used in each and every gomus Components
 * application.
 */
var COMMON_DIRECTIVES = [
    LocaleSwitcherDirective,
    TranslateDirective
];

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
// import { noopRollbarFactory, RollbarService, ErrorService, ConsoleLoggerService, LoggerService, defaultRollbarConfig, AlertService, RollbarAlertService } from '@gomus/core'
var configApi = {
    config: '/api/v4/shop'
};
/**
 * The module that includes Angular's common module including a custom version of  {\@link GoForOf}...
 *
 * \@stable
 */
var GomusCommonModule = (function () {
    // Note: We are injecting the Config so it gets created eagerly...
    function GomusCommonModule(config) {
    }
    /**
     * @param {?=} options
     * @return {?}
     */
    GomusCommonModule.forRoot = /**
     * @param {?=} options
     * @return {?}
     */
    function (options) {
        if (options === void 0) { options = {}; }
        return {
            ngModule: GomusCommonModule,
            providers: [
                { provide: END_POINTS, multi: true, useValue: configApi },
                { provide: GO_CONFIGURATION, useValue: options.go_config || noopConfiguration },
                COMMON_SERVICES,
                LoaderService
            ]
        };
    };
    /**
     * @param {?=} endpoints
     * @return {?}
     */
    GomusCommonModule.forChild = /**
     * @param {?=} endpoints
     * @return {?}
     */
    function (endpoints) {
        if (endpoints === void 0) { endpoints = {}; }
        return {
            ngModule: GomusCommonModule, providers: [
                { provide: END_POINTS, multi: true, useValue: endpoints }
            ]
        };
    };
    GomusCommonModule.decorators = [
        { type: core.NgModule, args: [{
                    imports: [
                        LoaderModule,
                        ModalModule
                    ],
                    declarations: COMMON_DIRECTIVES.concat(COMMON_PIPES),
                    exports: COMMON_DIRECTIVES.concat(COMMON_PIPES, [
                        LoaderModule,
                        ModalModule
                    ])
                },] },
    ];
    /** @nocollapse */
    GomusCommonModule.ctorParameters = function () { return [
        { type: ConfigService, decorators: [{ type: core.Optional },] },
    ]; };
    return GomusCommonModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/**
 * @license
 * Copyright Giant Monkey Software Engineering All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://github.com/giantmonkey/gomus-components/blob/master/LICENSE
 */
/**
 * @module
 * @description
 * Entry point for all public APIs of this package.
 */

exports.LoaderModule = LoaderModule;
exports.LoaderService = LoaderService;
exports.LoaderComponent = LoaderComponent;
exports.LoaderDirective = LoaderDirective;
exports.ModalModule = ModalModule;
exports.ModalService = ModalService;
exports.ModalComponent = ModalComponent;
exports.GoConfiguration = GoConfiguration;
exports.ConfigService = ConfigService;
exports.API = API;
exports.END_POINTS = END_POINTS;
exports.GO_CONFIGURATION = GO_CONFIGURATION;
exports.noopConfiguration = noopConfiguration;
exports.ConfigApiService = ConfigApiService;
exports.COMMON_SERVICES = COMMON_SERVICES;
exports.TranslatePipe = TranslatePipe;
exports.COMMON_PIPES = COMMON_PIPES;
exports.LocaleSwitcherDirective = LocaleSwitcherDirective;
exports.TranslateDirective = TranslateDirective;
exports.COMMON_DIRECTIVES = COMMON_DIRECTIVES;
exports.configApi = configApi;
exports.GomusCommonModule = GomusCommonModule;

Object.defineProperty(exports, '__esModule', { value: true });

})));
